import { render } from "./SkillColor.vue?vue&type=template&id=1bdf4bb6&scoped=true"
import script from "./SkillColor.vue?vue&type=script&lang=ts"
export * from "./SkillColor.vue?vue&type=script&lang=ts"

import "./SkillColor.vue?vue&type=style&index=0&id=1bdf4bb6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1bdf4bb6"

export default script